import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTemDefterAramaComponent} from './ctl-tem-defter-arama/ctl-tem-defter-arama.component';
import {TemDefterService} from './ctl-tem-defter.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';
import {ControlConditionModel} from "../../../models/gen-control.model";

@Component({
  selector: 'dk-ctl-tem-defter',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTemDefterAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ],
  providers: [TemDefterService],
  templateUrl: './ctl-tem-defter.component.html',
  styleUrls: ['./ctl-tem-defter.component.scss'],
})
export class CtlTemDefterComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() selectMode:string;
  @Input() labelMode: LabelMode = null;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "vTemDefterBakiye";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  public crudPopupVisible = false;
  public toastMessage: string;
  @Input() code: any;
  @Input() period!: number;
  @Input() receiptDate!: Date;
  @Input() accountCode!: string;
  @Input() corporateCode!: string;
  @Input() personCode!: number | undefined;
  @Input() validationRulesMap!: any[];
  @Input() conditionColName: any;
  @Input() conditionColText: any;
  @Input() controlCondition: ControlConditionModel[];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TemDefterService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Tem Defter)"
      this.showAction = false
    } else if (!this.accountCode) {
      this.toastMessage = "Lütfen Hesap Kodu Bilgisini Kontrol Ediniz.(Tem Defter)"
      this.showAction = false
    } else if (!this.receiptDate) {
      this.toastMessage = "Lütfen Fiş Tarihi Bilgisini Kontrol Ediniz.(Tem Defter)"
      this.showAction = false
    }

        this.service.setParams(this.period, this.receiptDate, this.accountCode, this.corporateCode, this.personCode, this.controlCondition,this.isReadOnly,this.isBindCheck)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes || changes['period']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period, this.receiptDate, this.accountCode, this.corporateCode, this.personCode, this.controlCondition,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.period, this.receiptDate, this.accountCode, this.corporateCode, this.personCode, this.controlCondition,this.isReadOnly,this.isBindCheck)
      }
  }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;
        }
      });
  }


  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {
    this.data = this.service.getData(Number(code),this.control, this.period,this.accountCode, this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].AdSoyadUnvan;
        this.code = result[0].DefterSiraNo;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.length === 1) {
      this.isFirst = true
      this.data = result[0];
      this.code = result[0].DefterSiraNo;
      this.title = result[0].AdSoyadUnvan;
      this.dataResult.emit(this.data);
    } else if (result?.length > 1) {
      this.dataResult.emit(result)
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
